import { MEDICATION_FORM_STATUSES } from 'services/medicationForms/constants'

export const MEDICATION_FORM_STATUS_COLORS = {
  [MEDICATION_FORM_STATUSES.ACTIVE]: '#098609',
  [MEDICATION_FORM_STATUSES.UPCOMING]: '#36A9E0',
  [MEDICATION_FORM_STATUSES.PAST]: '#989898',
  [MEDICATION_FORM_STATUSES.NEED_REVIEW]: '#FFA600',
  [MEDICATION_FORM_STATUSES.EXPIRED]: '#E20714',
}
